/**
 * Dashboard - Cast-in listing
 */

'use strict';

// Constructor
var FrontDashboardCastingIndex = function () {
    if (!($('body').hasClass('dashboard-casting') || $('body').hasClass('dashboard-casting-publish') || $('body').hasClass('dashboard-casting-draft') || $('body').hasClass('dashboard-casting-create'))) {
        return;
    }

    $(document).ready((function () {
        this.openModalCreate();
        this.formCreate();
        this.updateStatus();
        this.delete();
        this.uiMatchHeight();
    }).bind(this));
};

FrontDashboardCastingIndex.prototype = {
    lockAjaxForm: false,

    openModalCreate: function() {
        var $modalCreate = $('#modal-dashboard-casting-create');

        $modalCreate.modal({
            dismissible: false,
        });

        if (casting.state == 'create') {
            $modalCreate.modal('open');
        }

        $('main#content .create-casting').on('click', function() {
            $modalCreate.modal('open');
        });
    },

    formCreate: function() {
        var self = this;
        var $modalCreate = $('#modal-dashboard-casting-create');

        $('form', $modalCreate).submit(function(e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxForm = true;

            $('.preloader-wrapper', $modalCreate).fadeIn();

            $('button[type=submit]', $modalCreate).addClass('disabled');

            var ajaxAction = 'dashboard.casting.create';

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: $('form', $modalCreate).serialize() + "&action=" + ajaxAction + "&security=" + comedien.security,
            }).done(function(response) {
                if (response.success) {
                    location.replace(response.data.redirect);
                } else {
                    var nbErrors = Object.keys(response.data.errors).length;
                    if (nbErrors > 0) {
                        $.each(response.data.errors, function (i, item) {
                            $('#' + i, $modalCreate).addClass('invalid');
                            M.toast({html:'<span>'+ item +'</span>'}, 5000);
                        });
                    } else {
                       M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    }

                    $('button[type=submit]', $modalCreate).removeClass('disabled');
                    $('.preloader-wrapper', $modalCreate).hide();
                }

                self.lockAjaxForm = false;
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxForm = false;

                $('button[type=submit]', $modalCreate).removeClass('disabled');
                $('.preloader-wrapper', $modalCreate).hide();

               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
            });
        });
    },

    /**
     * Enable or disable the casting.
     */
    updateStatus: function() {
        var self = this;

        $('.item .update-status').change(function() {
            if (self.lockAjaxForm) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxForm = true;

            if ($(this).is(":checked")) {
                // Enable the post
                var status = 1;
            } else {
                // Disable the post
                var status = 0;
            }

            var item = $(this).parents('.item');

            $('.preloader-wrapper', item).fadeIn();

            var idPost = $(this).parents('.item').attr('data-id');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'dashboard.casting.update_status',
                    security: comedien.security,
                    idPost: idPost,
                    status: status
                }
            }).done(function (response) {
                if (response.success) {
                    $('.preloader-wrapper', item).fadeOut();

                    if (status == 0) {
                        //$('#dashboard-casting .item[data-id=' + idPost + ']').fadeOut();
                        M.toast({html: '<span>'+comedien.i18n.castingDeactivated+'</span>'}, 5000);
                    } else {
                        M.toast({html: '<span>'+comedien.i18n.castingActivated+'</span>'}, 5000);
                    }
                }

                self.lockAjaxForm = false;
                $('.preloader-wrapper', item).hide();
            }).fail(function (jqXHR, textStatus) {
                self.lockAjaxForm = false;
                $('.preloader-wrapper', item).hide();
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
            });
        });
    },

    delete: function() {
        var self = this;
        var $modal = $('#modal-dashboard-casting-delete');
        var idPost = 0;

        $('#dashboard-casting').on('click', '.item .btn-delete', function(e) {
            e.preventDefault();

            idPost = $(this).parents('.item').attr('data-id');

            $modal.modal('open');
        });

        $('.btn-confirm', $modal).on('click', function(e) {
            e.preventDefault();

            if (idPost == 0) {
                return;
            }

            if (self.lockAjaxForm) {
                // Pending AJAX request... wait
                return;
            }

            self.lockAjaxForm = true;

            $('.preloader-wrapper', $modal).fadeIn();
            $('.content-before .btn-confirm', $modal).addClass('disabled');
            $('.content-before .modal-action', $modal).addClass('disabled');

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    action: 'dashboard.casting.delete',
                    security: comedien.security,
                    idPost: idPost,
                }
            }).done(function (response) {
                $('.preloader-wrapper', $modal).fadeOut();

                if (response.success) {
                    $modal.find('.content-before').addClass('hidden');
                    $modal.find('.content-after').removeClass('hidden');
                    $('#dashboard-casting .item[data-id=' + idPost + ']').fadeOut(500).remove();

                    self.uiMatchHeight();
                } else {
                    $modal.modal('close');
                }

                idPost = 0;
                self.lockAjaxForm = false;
            }).fail(function (jqXHR, textStatus) {
                $('.preloader-wrapper', $modal).hide();
                self.lockAjaxForm = false;
                $modal.modal('close');
            });
        });
    },

    uiMatchHeight: function() {
        $('#dashboard-casting .item').matchHeight();
        $('main#content > .col').matchHeight();
    },
};

module.exports = new FrontDashboardCastingIndex();
